import cookies from 'js-cookie';
import { useContext, useEffect, useMemo } from 'react';
import { CreateAccountNavigationContext } from 'src/Booking/components/CreateAccountContainer';
import { PatientInfoFormContext } from 'src/Booking/components/PatientInfoForm/PatientInfoFormProvider';

/*
 * Require the patient info to already be entered before allowing the user
 * to continue any other parts of our create account flows, with a backdoor
 * for Cypress testing the rest of the flows
 */
export const useRequirePatientInfoComplete = () => {
    const patientInfoContext = useContext(PatientInfoFormContext);
    const { goBackToPatientInfo } = useContext(CreateAccountNavigationContext);

    const skipPatientInfoForTesting = cookies.get('skipPatientInfoForTesting');

    const patientInfoHasValue = useMemo(() => {
        // Make sure all fields have non-empty values
        return Object.entries(patientInfoContext.values)
            .map((entry) => {
                // eslint-disable-next-line no-unused-vars
                const [_, value] = entry;
                return value;
            })
            .every(Boolean);
    }, [patientInfoContext.values]);

    useEffect(() => {
        if (!patientInfoHasValue && !skipPatientInfoForTesting) {
            goBackToPatientInfo();
        }
    }, [goBackToPatientInfo, patientInfoHasValue, skipPatientInfoForTesting]);
};
